var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Env from './env';
import { compareVersion } from './utils';
import { API } from './api';
import { support, handle, fn } from './core';
import defaultAPIPlaceholderFns from './utils/defaultAPIPlaceholderFns';
var isAndroidApp = Env.isAndroidApp, isIOSApp = Env.isIOSApp, isApp = Env.isApp, appVersion = Env.appVersion;
function version() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // 无参数调用返回版本号
    if (args.length === 0) {
        return Env.appVersion;
    }
    else {
        // eslint-disable-next-line prefer-spread
        return compareVersion.apply(null, args);
    }
}
// callHandler透传外部调用的参数，对于不存在于API列表中的方法，可以使用其进行调用，但是不支持support方法检测
function callHandler() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // eslint-disable-next-line prefer-spread
    handle.apply(null, args);
}
// 分享的简写方法，为了向前兼容，非标准，不推荐使用
function share() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var fnName = args[0];
    var fnArgs = [fnName, API[fnName], args.slice(1)];
    // eslint-disable-next-line prefer-spread
    fn.apply(null, fnArgs);
}
var dbridge = __assign({ isIOSApp: isIOSApp, isAndroidApp: isAndroidApp, isApp: isApp, appVersion: appVersion, compareVersion: compareVersion, support: support, handle: handle, fn: fn, version: version, callHandler: callHandler, share: share }, defaultAPIPlaceholderFns);
Object.keys(API).forEach(function (key) {
    dbridge[key] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var fnArgs = [key, API[key], args];
        // eslint-disable-next-line prefer-spread
        fn.apply(null, fnArgs);
    };
});
export default dbridge;
export { dbridge };
export * from './types';
